import React, { useEffect, createElement } from 'react';
import { SalesPage } from './pages/SalesPage';
// Global utility for High-Precision Tracking and Hotmart Redirect
export const handleCheckoutRedirect = (baseUrl: string) => {
  try {
    // A & B) Trigger InitiateCheckout BEFORE redirection
    if (typeof (window as any).fbq === 'function') {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        value: 6.37,
        currency: 'USD'
      });
    }
    const url = new URL(baseUrl);
    const searchParams = new URLSearchParams(window.location.search);
    // C) Capture UTMs and fbclid
    const utmSource = searchParams.get('utm_source') || '';
    const utmMedium = searchParams.get('utm_medium') || '';
    const utmCampaign = searchParams.get('utm_campaign') || '';
    const utmContent = searchParams.get('utm_content') || '';
    const utmTerm = searchParams.get('utm_term') || '';
    const fbclid = searchParams.get('fbclid') || '';
    // Read cookies for CAPI (_fbp, _fbc)
    const getCookie = (name: string) => {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : '';
    };
    const fbp = getCookie('_fbp');
    const fbc = getCookie('_fbc') || (fbclid ? `fb.1.${Date.now()}.${fbclid}` : '');
    // Append all captured query parameters
    searchParams.forEach((value, key) => {
      url.searchParams.set(key, value);
    });
    // D) Generate combined string for src and sck parameters
    const combinedSrc = [utmSource, utmMedium, utmCampaign, utmContent, utmTerm].join('|');
    if (combinedSrc !== '||||') {
      url.searchParams.set('src', combinedSrc);
      url.searchParams.set('sck', combinedSrc);
    }
    // E) Append fbp and fbc tracking values
    if (fbp) url.searchParams.set('fbp', fbp);
    if (fbc) url.searchParams.set('fbc', fbc);
    // Redirect
    window.location.href = url.toString();
  } catch (e) {
    console.error('Tracking error:', e);
    // Robustness: Fallback redirect if anything fails
    window.location.href = baseUrl;
  }
};
export function App() {
  useEffect(() => {
    // =========================================================================
    // 1. META PIXEL / TRACKING INITIALIZATION
    // =========================================================================
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '28914431981489824');
    (window as any).fbq('track', 'PageView');
    (window as any).fbq('track', 'ViewContent', {
      content_name: 'The Midnight Magnet Protocol',
      content_category: 'Digital Product / Manifestation',
      content_ids: ['MM-001'],
      content_type: 'product',
      value: 6.37,
      currency: 'USD'
    });
    // =========================================================================
  }, []);
  return <SalesPage data-id="element-0" />;
}